import * as React from 'react';
import { NavLink, Link, RouteComponentProps } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar'
import * as NavDefaultStore from '../../../../store/menu/NavDefault';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store/index';
import * as LoginStore from '../../../../store/account/Login';
import * as ContactStore from '../../../../store/patient/Contact';
import * as SiteDetailStore from '../../../../store/SiteDetail';
import * as AccountStore from '../../../../store/siteaccount/Account';
import * as EncounterTypeStore from '../../../../store/patient/EncounterType';
import * as FlexFromStore from '../../../../store/library/flexiform/FlexiForm';
import * as SiteMenusStore from '../../../../store/siteaccount/siteMenu';
import * as MenuHideStore from '../../../../store/menuHide';
import LanguageList from '../LanguageList';
import MobLanguageList from '../MobLanguageList';
var patientLocalStroage: any = localStorage.getItem('Patient');
var patient = JSON.parse(patientLocalStroage);
var authLocalStroage: any = localStorage.getItem('isAuth');
type NavDefaultStoreProps = NavDefaultStore.NavDefaultState & SiteDetailStore.SiteDetailState & LoginStore.LoginState & AccountStore.AccountState & AccountStore.Settings & ContactStore.ContactState & EncounterTypeStore.EncounterTypeState & SiteMenusStore.SiteMenuState & FlexFromStore.FlexiListsState & MenuHideStore.MenuHideState & typeof NavDefaultStore.actionCreators & typeof SiteDetailStore.actionCreators & typeof LoginStore.actionCreators & typeof AccountStore.actionCreators & typeof ContactStore.actionCreators & typeof EncounterTypeStore.actionCreators & typeof SiteMenusStore.actionCreators & typeof FlexFromStore.actionCreators & typeof MenuHideStore.actionCreators & RouteComponentProps;
class NavPrime extends React.PureComponent<NavDefaultStoreProps> {
    public componentDidMount() {
        this.ensureDataFetched();
    }
    componentWillMount() {
        const script = document.createElement("script");
        script.src = "/Theme/Doccure/assets/js/script.js";
        script.async = true;
        document.body.appendChild(script);
        this.ensureDataFetched();

    }
    public render() {
        return (
            <React.Fragment>
                {this.renderDoctorList()}
            </React.Fragment>
        );
    }

    private ensureDataFetched() {

        /* this.props.requestSiteDetail();*/
        this.props.getDefaultAccount();
        this.props.requestEncounterType();
        this.props.getSiteMenu();
        if (localStorage.getItem("isAuth") == "true") {
            //this.props.getFormModule();
        }
    }
    public logOut() {
        this.props.requestLogout();
    }
    public login() {
        //localStorage.setItem("isAuth", "false");
        //console.log("ttt")
        return <NavLink to="/login" />;
    }
    goOurDoctor = () => {
        this.props.goNextPage();
    }
    public renderDoctorList() {
        //var data = document.location.pathname;
        //const _array = data.split('/');
        //if (_array[1] == "" || _array[1] == "login") {
        //    setTimeout(() => {
        //        var checkArray = String(this.props.navDefault.isAuth) == String(authLocalStroage);
        //        if (checkArray == false) {
        //            //localStorage.setItem("isAuth", "false");
        //            // window.location.href = "/login";
        //        }
        //    }, 300);
        //}
        //var link: any = document.querySelector("link[rel~='icon']");
        //if (!link) {
        //    link = document.createElement('link');
        //    link.rel = 'icon';
        //    document.getElementsByTagName('head')[0].appendChild(link);
        //}
        //link.href = this.props.siteDetail.FavIconPath == "" ? "client/logo/favicon.png" : this.props.siteDetail.FavIconPath;
        var formArray: any = [];
        formArray = this.props.moduleLists.filter(function (el: any) {
            return ((el.id == null) && (el.showOnce == true) && (el.moduleId != 71) && (el.moduleId != 86) && (el.moduleId != 59) && (el.moduleId != 41));
        });
        var publicMenus: any = [];
        publicMenus = this.props.siteMenus.filter((ca: any) => ca.TypeId == "1");
        var data = window.location.pathname;
        const _array = data.split('/');
        return (
            <React.Fragment>
                <header className="header">
                    <LoadingBar style={{ backgroundColor: '#15558d', height: '10px' }} className="loading" updateTime={100} maxProgress={95} progressIncrease={10} />
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header f25">
                            <a id="mobile_btn">
                                <span className="bar-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </a>
                            {
                                this.props.siteDetail != undefined ?
                                    <a href="/" className="navbar-brand logo customlogo">
                                        {
                                            this.props.siteDetail.LogoPath == "" || this.props.siteDetail.LogoPath == undefined || this.props.siteDetail.LogoPath == null ? this.props.siteDetail.Name : <img src={this.props.siteDetail.LogoPath} alt="Logo" />
                                        }
                                    </a> : ""
                            }
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {
                                    this.props.siteDetail != undefined ?
                                        <a href="/" className="menu-logo customlogo slidelogo">
                                            {
                                                this.props.siteDetail.LogoPath == "" || this.props.siteDetail.LogoPath == undefined || this.props.siteDetail.LogoPath == null ? this.props.siteDetail.Name : <img src={this.props.siteDetail.LogoPath} alt="Logo" />
                                            }
                                        </a> : ""
                                }
                                <a id="menu_close" className="menu-close">
                                    <i className="fas fa-times"></i>
                                </a>
                            </div>
                            <ul className="main-nav">
                                <li className="login-link">
                                    {
                                        this.props.navDefault.isAuth == true ?
                                            <React.Fragment>
                                                {
                                                    publicMenus.map((sitemenu: SiteMenusStore.siteMenu) =>
                                                        <a className="dropdown-item" style={{ color: "#787b7c", textTransform: "uppercase" }} href={sitemenu.Src}>{sitemenu.Title}</a>
                                                    )
                                                }
                                                {
                                                    formArray.length == 0 ?
                                                        <React.Fragment>
                                                            {_array[1] == "initialpageforms" ? "" : <NavLink className="dropdown-item" to="/dashboard">Dashboard</NavLink>}
                                                            <NavLink className="dropdown-item" to="/ourdoctors">Our Doctors</NavLink>
                                                        </React.Fragment> : ""
                                                }
                                                <NavLink className={this.props.isSettingsLoading ? "dropdown-item disabled" : "dropdown-item"} to="/login" onClick={() => this.logOut()}>Logout</NavLink>
                                            </React.Fragment> :
                                            <React.Fragment>
                                                {
                                                    publicMenus.map((sitemenu: SiteMenusStore.siteMenu) =>
                                                        <a className="dropdown-item" style={{ color: "#787b7c", textTransform: "uppercase"}} href={sitemenu.Src}>{sitemenu.Title}</a>
                                                    )
                                                }
                                                {
                                                    this.props.navisLoading == true ? "" : <NavLink hidden={this.props.isShow} className="dropdown-item dLogin" onClick={() => this.login()} to="/login">SIGN IN / SIGN UP</NavLink>
                                                }

                                            </React.Fragment>

                                    }
                                    <MobLanguageList />
                                </li>

                            </ul>

                        </div>
                        <ul className="nav header-navbar-rht">
                            {
                                publicMenus.map((sitemenu: SiteMenusStore.siteMenu) =>
                                    <li>
                                        <a href={sitemenu.Src} style={{ textTransform: "uppercase" }}>{sitemenu.Title}</a>
                                    </li>
                                )
                            }
                            {
                                this.props.navDefault.isAuth == false || authLocalStroage == false ?
                                    <li>{
                                        this.props.navisLoading == true ? "" : <NavLink hidden={this.props.isShow} onClick={() => this.login()} className="nav-link header-login nav-top dLogin" to="/login">Sign In / Sign Up</NavLink>
                                    }
                                    </li>
                                    :
                                    <li className="nav-item dropdown has-arrow logged-item">
                                        <a href="#" className="dropdown-toggle nav-link" data-toggle="dropdown">
                                            <span className="user-img">
                                                <img className="rounded-circle" src={this.props.contact.photo == "" || this.props.contact.photo == undefined ? "client/default/img/blankimg.jpg" : this.props.contact.photo} width="31" alt="" />
                                            </span>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right">{
                                            this.props.patient != undefined ?
                                                <div className="user-header">
                                                    <div className="user-text">
                                                        <h6>{this.props.contact.firstName + " " + this.props.contact.lastName} </h6>
                                                    </div>
                                                </div> : ''
                                        }
                                            {
                                                formArray.length == 0 ? _array[1] == "initialpageforms" ? "" :
                                                    <NavLink className="dropdown-item" style={{ padding: '10px 25px' }} to="/dashboard">Dashboard</NavLink>
                                                    : ""
                                            }
                                            <a className={this.props.isSettingsLoading ? "dropdown-item disabled" : "dropdown-item"} style={{ padding: '10px 25px' }} onClick={() => this.logOut()}>Logout</a>
                                        </div>
                                    </li>
                            }

                        </ul>
                        <ul className="nav header-navbar-rht" style={{ marginLeft: "0px" }}>
                            <LanguageList />
                        </ul>
                    </nav>
                    <section>
                        <LoadingBar style={{ backgroundColor: '#15558d', height: '2px' }} className="loading" updateTime={100} maxProgress={90} progressIncrease={10} scope="sectionBar" />
                    </section>
                </header>
            </React.Fragment>
        );
    }
}
export default connect(
    (state: ApplicationState) => ({ ...state.navDefault, ...state.login, ...state.siteDetail, ...state.account, ...state.contact, ...state.encountertypes, ...state.flexiform, ...state.siteMenus, ...state.menuHide }), // Selects which state properties are merged into the component's props
    ({ ...NavDefaultStore.actionCreators, ...LoginStore.actionCreators, ...SiteDetailStore.actionCreators, ...AccountStore.actionCreators, ...ContactStore.actionCreators, ...EncounterTypeStore.actionCreators, ...MenuHideStore.actionCreators , ...FlexFromStore.actionCreators, ...SiteMenusStore.actionCreators }) // Selects which action creators are merged into the component's props
)(NavPrime as any);